import { render, staticRenderFns } from "./TxPool.vue?vue&type=template&id=2f3b5e3b"
import script from "./TxPool.vue?vue&type=script&lang=js"
export * from "./TxPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports